import {
  CompositionDataItem,
  OperationCompositionItem,
} from 'src/types/wallet';

export function getWalletCompositionData(
  composition: OperationCompositionItem[] | undefined,
): CompositionDataItem[] {
  const totalOperations = composition?.reduce(
    (total, item) => total + item.operations,
    0,
  );

  return (composition ?? []).map((item) => ({
    _key: item.product,
    quotasAmount: item.operations,
    value: totalOperations ? (item.operations / totalOperations) * 100 : 0,
  }));
}
